export const ROUTES_MOBILE = [
    { value: '/inicio', label: 'Inicio' },
    { value: '/wallet', label: 'Agregar fondos' },
    { value: '/referenciados', label: 'Referidos' },
    { value: '/movimientos/historial', label: 'Historial' },
    { value: '/movimientos/mis-inversiones', label: 'Mis inversiones' },
    { value: '/movimientos/calendario-de-pagos', label: 'Calendario de pagos' },
    { value: '/movimientos/mercado-secundario', label: 'Mercado secundario' },
    { value: '/movimientos/estado-de-operacion', label: 'Estado de operación' },
    { value: '/proyecto/mercado/en-fondeo', label: 'Oportunidades activas' },
    { value: '/mercado-secundario', label: 'Mercado secundario' },
    { value: '/proyecto/mercado/fondeados', label: 'Proyectos fondeados' },
    { value: '/cuenta', label: 'Mi cuenta' },
    { value: '/configuracion', label: 'Configuración' },
    { value: '/desarrollador', label: 'Desarrollador' },
    { value: '/desarrollador/perfil/configuracion', label: 'Configuarción' },
    { value: '/retiro', label: 'Retiro' },
    { value: '/proyecto/', label: 'Proyectos' },
    { value: '/movimientos', label: 'Mis movimientos' },
    { value: '/mi-cuenta', label: 'Mi cuenta' },
    { value: '/mi-cuenta/perfil', label: 'Mi Perfil' },
    { value: '/mi-cuenta/ajustes', label: 'Ajustes de cuenta' },
    { value: '/mi-cuenta/estado-de-cuenta', label: 'Estados de operación' },
    { value: '/mi-cuenta/documentos', label: 'Documentos' },
    { value: '/mis-inversiones', label: 'Mis inversiones' },
    { value: '/mi-cuenta/perfil/mis-beneficiarios/editar-beneficiario', label: 'Editar beneficiario' },
    { value: '/mi-cuenta/perfil/mis-beneficiarios/agregar-beneficiario', label: 'Agregar beneficiario' },
    { value: '/mi-cuenta/ajustes/autoinversion', label: 'AutoGrowth' },
    { value: '/mi-cuenta/ajustes/domiciliacion', label: 'Domiciliación' },
    { value: '/mi-cuenta/documentos/mis-certificados', label: 'Mis certificados' },
    { value: '/calendario-pagos', label: 'Calendario de pagos' },
    { value: '/invertir', label: 'Invertir' },
]